module.exports = __webpack_public_path__ + "static/media/b.7bd5215d.m4a";